// extracted by mini-css-extract-plugin
export default {"termsContainer":"TermsOfService_termsContainer__1Eias","termsContent":"TermsOfService_termsContent__c2gZS"};